import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {DataConfig} from '../../models/tabs-data';
import {SiteDataService} from '../../../site/services/site-data.service';
import { PlayerConfigurationDefinition} from '../../models/player-config-list-option';
import {GetFormsService} from '../../services/get-forms.service';
import {GetConfigSiteService} from '../../../site/services/get-config-site.service';
import { Store} from '@ngrx/store';
import * as fromShared from '../../reducers';
import { Subscription} from 'rxjs';
import {ClearPlayerConfigurationDefinitionAction, LoadPlayerConfigurationDefinitionAction} from '../../actions/player-configuration-definition';
import {ClearPlayerConfigurationEditFailAction, LoadPlayerConfigurationEditAction} from '../../actions/player-configuration-edit';
import {FormGroup} from '@angular/forms';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';

@Component({
  selector: 'storever-player-configuration-edit',
  templateUrl: './player-configuration-edit.component.html',
  styleUrls: ['./player-configuration-edit.component.scss'],
})
export class PlayerConfigurationEditComponent implements OnInit, OnDestroy {
  dataConfig: DataConfig;
  isData = false;
  form: FormGroup;
  itemUp: PlayerConfigurationDefinition;

  private sub$: Subscription;
  private subscriptions = [];

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale,
              private store: Store<fromShared.AppState>,
              private siteDataService: SiteDataService,
              private getFormsService: GetFormsService,
              private getConfigSiteService: GetConfigSiteService) {
  }
  ngOnInit(): void {
   this.store.dispatch(new LoadPlayerConfigurationDefinitionAction());
   this.store.dispatch(new LoadPlayerConfigurationEditAction());
   this.siteDataService.destroy();
   this.siteDataService.waitConfDefAndConfForm();
   this.sub$ = this.siteDataService.getResponse().subscribe((data) => {
     if (data['form'] && data['groupConfigs']) {
         this.dataConfig.form = data['form'];
         this.form = this.dataConfig.form.value;
         this.dataConfig.groupConfigs = data['groupConfigs'];
         this.dataConfig.form.markAsDirty();
     } else { // we init the form and config at empty when config edit is empty
       this.dataConfig.form = this.getFormsService.getPlayerConfiguration();
       this.dataConfig.groupConfigs = this.getConfigSiteService.getPlayerConfigurationsConfigs();
     }
     this.isData = true;

    });
   this.subscriptions.push(this.sub$);

  }
  /**
   * cette fonction ajoute une nouvelle options au formulaire si existe pas dans la config
   * si cette nouvelle option existe dans la config il va seulement la rendre visible
   */
  addOption(item: PlayerConfigurationDefinition): void {
    this.itemUp = item;
  }

  ngOnDestroy(): void {
    if (this.subscriptions.length) {
      this.subscriptions.forEach(sub => sub.unsubscribe());
    }
    this.isData = false;
    this.store.dispatch(new ClearPlayerConfigurationDefinitionAction());
    this.store.dispatch(new ClearPlayerConfigurationEditFailAction());
    this.siteDataService.destroy();
  }


}
